import { useEffect, useState } from "react";

import moment from "moment";
import { PageTopBreadcrumb } from "../../PageTopBreadcrumb";
import {
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Grid,
  Card,
  TextField,
  CardContent,
  Typography,
  Box,
} from "@mui/material";
import { IuguPagination } from "./IuguPagination";
import CancelIcon from "@mui/icons-material/Cancel";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { ActionIconButton } from "../../ActionIconButton";
import { statusLabels } from "./iugu-utils";
import { truncateString } from "../../../ra-components/users/UserUtils";
import { IdChip } from "../../IdChip";

export const IuguInvoicesPage = () => {
  const queryUrl = window.location.href;
  // extract uid from url
  let iugu_id = queryUrl.split("/").pop();
  iugu_id = iugu_id ? iugu_id.split("=").pop() : "";

  if (iugu_id === "iugu-invoices") {
    iugu_id = "";
  }

  const [invoices, setInvoices] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState<number | null>(null);
  const [query, setQuery] = useState(iugu_id || "");

  const cancelInvoice = async (id: string) => {
    const auth = localStorage.getItem("auth");
    const authJson = auth ? JSON.parse(auth) : auth;

    const response = await fetch(
      `${process.env.REACT_APP_API_PATH}/iugu/invoices/${id}/cancel`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authJson.access_token,
        },
      }
    );
    const data = await response.json();
    console.log({ data });
    window.location.reload();
  };
  const getInvoices = async () => {
    const auth = localStorage.getItem("auth");
    const authJson = auth ? JSON.parse(auth) : auth;
    const start = (page - 1) * perPage;

    // https://api.iugu.com/v1/invoices?start=${(page - 1) * 5}&limit=5
    const response = await fetch(
      `${process.env.REACT_APP_API_PATH}/iugu/invoices?s=${start}&l=${perPage}&q=${query}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + authJson.access_token,
        },
      }
    );
    const data = await response.json();
    console.log({ getInvoices: data });
    setInvoices(data.items);
    setTotalItems(typeof data.totalItems === "number" ? data.totalItems : null);
    return data;
  };
  useEffect(() => {
    getInvoices();
  }, [page, perPage, query]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <PageTopBreadcrumb
          title="Faturas IUGU"
          firstPath="/#/iugu-invoices"
          actionType="create"
        />
        <Card sx={{ padding: 2, marginBottom: 3 }}>
          {/* <CardHeader title={"Informações Pessoais"} /> */}

          <CardContent>
            {/* hiddenLabel: sem rótulo, a variante "filled" do tema
                reservava o espaço dele e empurrava o texto para baixo */}
            <TextField
              type="text"
              placeholder="Pesquisar"
              hiddenLabel
              helperText="E-mail, nome, anotações e ID da fatura"
              defaultValue={iugu_id}
              onChange={(e) => {
                setQuery(e.target.value);
              }}
            />
            {/* {JSON.stringify(invoices)} */}
            <TableContainer>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Dados da Fatura</TableCell>
                    <TableCell>Itens</TableCell>
                    {/* <TableCell>Vencimento</TableCell> */}
                    <TableCell align="right">Ações</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {invoices.map((invoice: any) => (
                    <TableRow key={invoice.id}>
                      <TableCell>
                        <IdChip value={invoice.id} />
                        <Typography variant="caption">
                          <br />
                          <b>Cliente:</b> {invoice.customer_name || "Sem nome"}{" "}
                          ({invoice.customer_id || "Sem ID"})
                          <br />
                          <b>E-mail:</b> {invoice.email || "Sem email"}
                          <br />
                          <b>Status:</b>{" "}
                          {statusLabels[invoice.status] || invoice.status}
                          <br />
                          {invoice.paid_at && (
                            <>
                              <b>Pago: </b>
                              {invoice.paid}
                              <br />
                              <b>Pago em: </b>{" "}
                              {moment(invoice.paid_at).format("DD-MM-YYYY")}
                              <br />
                            </>
                          )}
                          <b>Vencimento:</b>{" "}
                          {moment(invoice.due_date).format("DD-MM-YYYY")}
                        </Typography>
                      </TableCell>
                      <TableCell>
                        <Table size="small">
                          <TableHead>
                            <TableRow>
                              <TableCell>Item</TableCell>
                              <TableCell>Qntd.</TableCell>
                              <TableCell>Valor</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {invoice.items.map((item: any) => (
                              <TableRow key={item.id}>
                                <TableCell>{item.description}</TableCell>
                                <TableCell>{item.quantity}</TableCell>
                                <TableCell>
                                  R$ {(item.price_cents / 100).toFixed(2)}
                                </TableCell>
                              </TableRow>
                            ))}
                            <TableRow>
                              <TableCell>
                                <Typography variant="caption">
                                  <b>Total</b>
                                </Typography>
                              </TableCell>
                              <TableCell></TableCell>
                              <TableCell>
                                <Typography variant="caption">
                                  <b>
                                    R${" "}
                                    {(parseInt(invoice.total_cents) / 100)
                                      .toFixed(2)
                                      .replace(".", ",")}
                                  </b>
                                </Typography>
                              </TableCell>
                            </TableRow>
                          </TableBody>
                        </Table>
                      </TableCell>

                      <TableCell align="right">
                        <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end" }}>
                          <ActionIconButton
                            title="Visualizar fatura"
                            icon={<VisibilityIcon fontSize="small" />}
                            onClick={() => {
                              window.open(`${invoice.secure_url}`);
                            }}
                          />
                          <ActionIconButton
                            title="Cancelar fatura"
                            variant="danger"
                            icon={<CancelIcon fontSize="small" />}
                            disabled={
                              invoice.status === "canceled" ||
                              invoice.status === "paid"
                            }
                            onClick={() => {
                              cancelInvoice(invoice.id);
                            }}
                          />
                        </Box>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
            <IuguPagination setPage={setPage} page={page} list={invoices} totalItems={totalItems} perPage={perPage} setPerPage={setPerPage} />
        </CardContent>
      </Card>
      </Grid>
    </Grid>
  );
};
